exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-dialog[data-v-4de533b7]{min-width:320px;padding:4px}.buttons[data-v-4de533b7]{margin-top:16px;text-align:right}.form[data-v-4de533b7]{margin-bottom:20px}.fields .field[data-v-4de533b7]:first-child{padding-left:0px}.fields .field[data-v-4de533b7]:last-child{padding-right:0px}.ui.form .fields[data-v-4de533b7]{margin-left:0;margin-right:0}.content[data-v-4de533b7]{overflow:hidden}", ""]);

// exports
